.root {
    font: var(--font-p-16);
    color: var(--black);

    address {
        font-style: normal;
    }
}

.li {
    composes: root;
    margin-block: var(--spacer-16);
    padding-block: var(--spacer-16);
    border-bottom: 1px solid var(--black);
}

.clickable {
    width: 100%;
    text-align: left;
}

.popover {
    composes: root;
    min-width: 200px;
}

.locationName {
    font: var(--font-h-24);
}

.glyph {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: var(--spacer-32);
    aspect-ratio: 4 / 5;
    font-weight: 700;
}

.markerGlyph {
    font-size: 16px;
    font-weight: bold;
}

.pin {
    position: absolute;
    inset: 0;
    stroke: var(--red);
    fill: var(--white);
    stroke-width: 3;
    z-index: -1;
}

.itemWithIcon {
    display: flex;
    gap: var(--spacer-8);
    margin-block: var(--spacer-8);
}

.textLink {
    composes: fontTextLink from "../../styles/composable/typography.module.css";
    display: block;
}

.svg {
    width: var(--spacer-24);
    height: var(--spacer-24);
    fill: var(--black);
    flex-shrink: 0;
}

.appliancesAvailable {
    composes: itemWithIcon;
    margin-top: var(--spacer-24);
    color: var(--medium-gray);
    font: var(--font-p-16);
}

.checkSvg {
    composes: svg;
    fill: var(--red);
}
